<template>
  <MainLayout>
    <ContentCard class="w-full pb-16 text-center">
      <!-- To Do: Replace with similar image that includes 404  -->
      <img
        src="@/assets/404-illustration.svg"
        alt="illustration of an empty office"
        class="m-auto p-8"
      />
      <h4 class="pb-4">Uh Oh.</h4>
      <p class="pb-6">We must've taken a wrong turn.</p>
      <ToznyButton
        @click.native="routeToDashboard"
        class="m-auto"
        buttonText="Dashboard"
      />
    </ContentCard>
  </MainLayout>
</template>

<script>
// @ is an alias to /src
import ContentCard from '@/Common/ContentCard'
import MainLayout from '@/Common/MainLayout/MainLayout'
import ToznyButton from '@/Common/ToznyButton'
import { mapActions } from 'vuex'
export default {
  name: 'NotFound',
  components: {
    ContentCard,
    MainLayout,
    ToznyButton,
  },
  methods: {
    ...mapActions(['pushRoute']),
    routeToDashboard: function () {
      this.pushRoute('/')
    },
  },
}
</script>
